import { render, staticRenderFns } from "./ListGroupPermission.vue?vue&type=template&id=69bcc521&scoped=true&"
import script from "./listGroupPermission.ts?vue&type=script&lang=ts&"
export * from "./listGroupPermission.ts?vue&type=script&lang=ts&"
import style0 from "./ListGroupPermission.vue?vue&type=style&index=0&id=69bcc521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bcc521",
  null
  
)

export default component.exports